<template>
    <div v-show="layout === 'landing'" class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>
    <sidenav v-if="showSidenav" />
    <main class="main-content position-relative max-height-vh-100 h-100">
        <navbar v-if="showNavbar" />
        <router-view />
        <app-footer v-show="showFooter" />
    </main>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

import Sidenav from "./examples/Sidenav";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";

const store = useStore();
const layout = computed(() => store.state.layout);
const showSidenav = computed(() => store.state.showSidenav);
const showNavbar = computed(() => store.state.showNavbar);
const showFooter = computed(() => store.state.showFooter);

</script>